<script setup lang="ts">
import { BoardBasisTag } from '@apps/main/new-desktop/modules/boardBasisTag';
import { getBoardBasisText } from '@apps/main/new-desktop/core/helpers/translation.helper';

import { AppSvgIcon } from '@libs/ui';
import type { BoardBasisCode } from '@libs/trip-planner-interfaces';

interface PeekPriceSingleRoomProps {
  roomDescription: string;
  boardBasisCode?: BoardBasisCode;
}

const props = defineProps<PeekPriceSingleRoomProps>();
</script>

<template>
  <div class="peek-price-single-room">
    <div class="room-description">
      <AppSvgIcon name="bedOutlined" size="18" color="color-neutral-70" />
      <div class="text-ellipsis">
        {{ props.roomDescription }}
      </div>
    </div>
    <BoardBasisTag
      v-if="props.boardBasisCode"
      :board-basis-code="props.boardBasisCode"
      :are-other-board-basis-options-available="false"
      :translations-callback="getBoardBasisText"
    />
  </div>
</template>

<style scoped lang="scss">
.peek-price-single-room {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-8);

  .room-description {
    display: flex;
    gap: var(--spacing-8);

    .text-ellipsis {
      color: var(--color-neutral-70);
      @include font-body-s-light;

      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
